import {PureComponent, ReactNode} from "react"
import {isFunction} from "lodash"
import {hangPromise} from "@irati/utils/promise"
import getTenantFromPath from "@irati/identity/helpers/getTenantFromPath/index"
import getRegionHelper from "../helpers/getRegion"

interface RenderProps {
  load: Promise<any>
}

interface Props {
  useSubdomain: boolean
  children: ((renderProps: RenderProps) => ReactNode) | ReactNode
}

interface State {
  load: Promise<any>
}

export default class RegionProvider extends PureComponent<Props, State> {
  static defaultProps = {
    useSubdomain: false
  }

  state = {
    load: hangPromise()
  }

  componentDidMount() {
    const {useSubdomain} = this.props
    if (useSubdomain) {
      const load = getRegionHelper(getTenantFromPath())
      this.setState({load})
    } else {
      this.setState({load: Promise.resolve()})
    }
  }

  render() {
    const {children} = this.props
    const {load} = this.state

    if (isFunction(children)) {
      return children({load})
    }

    return children
  }
}
